module.exports = __webpack_public_path__ + "static/media/flowers.fe2323c0.jpg";